import { Boxes } from 'lucide-react';

import { defineTour } from '@nucleus-commerce/admin-kit/tour';

export const inventoryLevelsTour = defineTour({
  id: 'inventory.levels',
  version: 1,
  group: 'catalog',
  route: '/_authed/_active/s/$storeId/inventory',
  scope: 'store',
  requires: 'inventory.read',
  icon: Boxes,
  steps: [
    {
      id: 'list',
      kind: 'explain',
      variants: [
        { target: 'inventory.levels.table' },
        { target: 'inventory.levels.empty', copy: 'empty' },
      ],
    },
    {
      id: 'reorder-point',
      kind: 'explain',
      target: 'inventory.levels.reorder-point',
      optional: true,
    },
    { id: 'filters', kind: 'explain', target: 'inventory.levels.filters', optional: true },
    { id: 'row-actions', kind: 'explain', target: 'inventory.levels.row-actions', optional: true },
    { id: 'locations', kind: 'explain', target: 'inventory.levels.locations-button' },
  ],
  related: ['settings.locations', 'reports.inventory'],
});
